import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';
import { OKButton } from 'components/commons/OKButton/OKButton';
const { OKIconTask } = require('commonsComponents/OKIconTask');

import 'react-virtualized/styles.css';

const { formatText, FormattedText } = i18n;

export const DocumentsModalScrollInfo = ({
    handleClickCloseButton,
    handleClickGif,
    handleClickCancelButton,
    handleClickContinueButton,
}) => {
    return (
        <div className={'documents__modal__scroll-info__box-outside'}>
            <div className={'documents__modal__scroll-info__box-inside'}>
                <div className="documents__modal__scroll-info__container">
                    <div className="documents__modal__scroll-info-heading">
                        <div className="documents__modal__scroll-info-heading__close-icon">
                            <button onClick={handleClickCloseButton}>
                                <OKIconTask
                                    activeHover={false}
                                    icon="icon-cerrar"
                                    style="default"
                                    type="circle"
                                />
                            </button>
                        </div>
                        <h4>{formatText('contractsView-dic_title')}</h4>
                    </div>
                    <div className="documents__modal__scroll-info-body">
                        <div className="documents__modal__scroll-info-body-gif">
                            {
                                // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                                <span onClick={handleClickGif} className="icons--mandatory-scroll-icon" />
                            }
                        </div>
                        <FormattedText value="contractsView-dic_leaveText" />
                    </div>
                    <div className="documents__modal__scroll-info-buttons">
                        <span>
                            <OKButton modifier="link-ghost" onClick={handleClickCancelButton}>
                                {formatText('common-exit')}
                            </OKButton>
                        </span>
                        <OKButton onClick={handleClickContinueButton}>
                            {formatText('contractsView-dic_buttonUnderstood')}
                        </OKButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

DocumentsModalScrollInfo.propTypes = {
    handleClickCloseButton: PropTypes.func,
    handleClickGif: PropTypes.func,
    handleClickCancelButton: PropTypes.func,
    handleClickContinueButton: PropTypes.func,
};
